var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowCaroualGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 50,
    viewBox: "0 0 26 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0928 27.4753L6.06997 48.9738C4.85988 50.3421 2.89794 50.3421 1.68845 48.9738C0.478852 47.6067 0.478852 45.3895 1.68845 44.0226L18.5207 24.9996L1.68893 5.97738C0.479341 4.60977 0.479341 2.39276 1.68893 1.02571C2.89853 -0.341902 4.86037 -0.341902 6.07046 1.02571L25.0933 22.5246C25.6981 23.2084 26.0002 24.1038 26.0002 24.9995C26.0002 25.8957 25.6975 26.7917 25.0928 27.4753Z",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowCaroualGray);
export default __webpack_public_path__ + "static/media/right-arrow-caroual-gray.b7d81703daf333a1d2e319bf68e69f14.svg";
export { ForwardRef as ReactComponent };